import { compareTwoLinkArrays } from "./functions";

const sortOptions = {
  up: "up",
  down: "down",
};

const controlOptions = {
  add: "add",
  remove: "remove",
  reset: "reset",
  datasourcechange: "datasourcechange",
};

function removeLinkFromState(state, newLink) {
  if (!newLink.title || !newLink.title) {
    return state;
  }
  return state.filter((o) => o.link !== newLink.link);
}

function addLinkToState(state, newLinks) {
  if (!newLinks?.length) {
    return state;
  }
  
  let dedupedList = state.filter(existingLink => {
    const matchInNewList = newLinks.find(newLink => {
      return newLink.link === existingLink.link || newLink.title === existingLink.title
    })
    return !matchInNewList
  })

  return [...dedupedList, ...newLinks];
}

const compare = (existingList = [], newList = []) => {
  return (newList?.length >= 3) && compareTwoLinkArrays(existingList, newList)
}

function reducer(state = {
  list: [],
  history: []
}, action = {}) {
  const { link, links = [], type, hide } = action ?? {};
  const predicate = (l) => l.link === link.link;
  const shape = {
    ...state,
    lastAction: action,
    list: state?.list || [],
  }
  if(controlOptions.datasourcechange === type) {
    const useNew = compare(state?.list, action?.links ?? [])
    if(useNew) {
      return {
        ...shape,
        list: action.links
      }
    }
    return shape
  }

  if(controlOptions.reset === type) {
    shape.list = action?.links ?? []
    return shape
  }

  if (hide !== undefined) {
    shape.list = state.map((o) => {
      const isMatch = predicate(o);
      if (isMatch) {
        return {
          ...o,
          hide,
        };
      }
      return o;
    });
    return shape;
  } else if (type === controlOptions.add) {
    shape.list = addLinkToState(shape.list, links);
    return shape;
  } else if (type === controlOptions.remove) {
    const indexOf = shape.list.findIndex(o => o.link === link?.link)
    shape.lastAction.indexOf = indexOf
    shape.list = removeLinkFromState(shape.list, link);
    return shape;
  }
  if (type !== sortOptions.up && type !== sortOptions.down) {
    return shape;
  }

  const match = shape.list.findIndex(predicate);
  const stateWithoutMatch = shape.list.filter((link) => !predicate(link));
  const firstItem = match === 0;
  const lastItem = match === shape.list.length - 1;
  const itemsBefore = shape.list.slice(0, match);
  const itemsAfter = shape.list.slice(match + 1);

  if (lastItem && type === sortOptions.down) {
    shape.list = [link, ...stateWithoutMatch];
  } else if (firstItem && type === sortOptions.up) {
    shape.list = [...stateWithoutMatch, link];
  } else if (type === sortOptions.down) {
    const newItemBefore = itemsAfter.shift();
    shape.list = [...itemsBefore, newItemBefore, link, ...itemsAfter];
  } else if (type === sortOptions.up) {
    const lastOfItemsBefore = itemsBefore.pop();
    shape.list = [...itemsBefore, link, lastOfItemsBefore, ...itemsAfter];
  }

  return shape;
}

export { reducer, sortOptions, controlOptions };
